<template>
  <div>
    <filters-bar
    title="Gestiones"
    title-class="headline"
    :filters="filters"
    :has-channel="true"
    :has-date-type="true"
    @search="setFilters">
      <template slot="content">
        <v-flex md2>
          <v-btn block class="h-100 ma-0 w-100" @click="showModal = true">
            <v-icon small>fas fa-download</v-icon>
          </v-btn>
        </v-flex>
      </template>
    </filters-bar>
    <v-layout row wrap pa-0 ma-0 justify-end>
      <p class="caption" v-if="date">
        Ultima actualización {{ date }}
      </p>
    </v-layout>
    <graphics
      graphic-id-one="totalsScheduleGraphic"
      graphic-id-two="sendsScheduleGraphic"
      :filters="filters"
      url="notification_schedules/schedules_status"
    ></graphics>
    <download-modal
      :show="showModal"
      @change="showModal = $event"
      title="Seleccione el tipo de archivo a descargar"
      :items="downloadOptions"
      :filtered-select="true"
      :items-filter="fileOptions"
      label="Tipo de contactabilidad"
      @download="generateReportV2"
    >
      <div slot="filteredHeader">Cargue el archivo con el que va a filtrar</div>
      <div slot="filteredContent">
        <input type="file" ref="file" @change="handleFileUpload()" />
      </div>
    </download-modal>
  </div>
</template>

<script>
import EventBus from '@/event-bus';
import moment from 'moment';
import reportsListMixin from '@/mixins/reportsList';
import FiltersBar from '@/components/global/FiltersBar';
import graphics from '@/components/panel/schedules/Graphics';
import DownloadModal from '@/components/panelV2/DownloadModal';

export default {
  props: {
    campaignFilter: {
      type: Boolean,
      default: false,
    },
    date: {
      type: String,
    },
  },
  mixins: [
    reportsListMixin,
  ],
  components: {
    graphics,
    FiltersBar,
    DownloadModal,
  },
  data() {
    return {
      filterActive: false,
      filters: {
        date: moment().format('YYYY-MM-DD'),
        dateType: 'date',
        channel: 4,
        campaign: this.campaignFilter,
        total_load: 0,
        company_load: 0,
      },
      showModal: false,
      downloadOptions: [
        {
          text: 'Con contacto',
          value: 1,
        },
        {
          text: 'Sin contacto',
          value: 0,
        },
      ],
      fileOptions: [
        {
          text: 'Reporte de contactabilidad general',
          value: 0,
        },
        {
          text: 'Reporte filtrado por archivo de cuentas',
          value: 1,
        },
      ],
    };
  },
  methods: {
    setFilters(filters) {
      this.filters = {
        ...this.filters,
        ...filters,
      };
    },
    generateReport() {
      EventBus.$emit('startListenEvent');
      const data = {
        filters: { ...this.filters },
        functionName: 'managementTotal',
      };
      data.filters.from = data.filters.date;
      this.axios.post('/reports', data).then(() => {
        EventBus.$emit('infoModal',
          'Se esta generando su archivo, se le informara cuando este listo el reporte, por favor espere.',
          'fas fa-check-double');
      });
    },
    generateReportV2(contacted, filtered) {
      let functionName = '';
      if (!filtered) {
        const obj = {
          ..._.pick(this.filters, [
            'date',
            'dateType',
            'total_load',
            'company_load',
          ]),
        };
        obj.last_company_load = obj.company_load;
        delete obj.company_load;
        if (this.filters.dateType === 'date') {
          functionName = 'customerReport';
        } else {
          functionName = 'contactability';
        }
        this.$store.commit(
          'SET_DOWNLOAD_CHANNEL',
          `company.${this.$auth.user().company.id}.${this.$auth.user().id}.download_report`,
        );
        this.$store.dispatch('SEND_DOWNLOAD_REQUEST', {
          route: 'reports',
          params: {
            filters: {
              ...obj,
              conditions: this.channels,
              contacted,
              filename: 'Contactabilidad de clientes',
            },
            functionName,
          },
        });
      } else {
        functionName = 'contactability_by_filter';
        const formData = new FormData();
        formData.append('file', this.file);

        this.axios.post('/reports/upload', formData).then((response) => {
          this.$store.commit(
            'SET_DOWNLOAD_CHANNEL',
            `company.${this.$auth.user().company.id}.${this.$auth.user().id}.download_report`,
          );
          this.$store.dispatch('SEND_DOWNLOAD_REQUEST', {
            route: 'reports',
            params: {
              filters: {
                filename: response.data,
              },
              functionName,
            },
          });
        });
      }
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
  },
};
</script>

<style>
.w-auto {
  width: auto !important;
}
</style>


// WEBPACK FOOTER //
// src/components/panel/schedules/Index.vue